import { icon } from '@/icons/icons';
import { pickDirectory, restoreDirectory, listDocx, type DirEntry } from '@/files/fileSystem';
import { openFromHandle } from '@/files/docService';
import { store } from '@/state/store';

// ═══════════════════════════════════════════════════════════════
// Postranní panel "Průzkumník souborů" (sekce 2.5)
// Strom lokální složky (jako VS Code file explorer) — .docx soubory,
// klik otevře v editoru. Zapamatuje poslední složku (IndexedDB).
// ═══════════════════════════════════════════════════════════════

export class FileExplorer {
  private root: HTMLElement;
  private listEl!: HTMLElement;
  private dirNameEl!: HTMLElement;

  constructor(mount: HTMLElement) {
    this.root = document.createElement('aside');
    this.root.className = 'file-explorer';
    this.build();
    mount.appendChild(this.root);
    void this.tryRestore();
  }

  private build() {
    this.root.innerHTML = `
      <div class="fx-header">
        <span class="fx-title">Průzkumník souborů</span>
        <button class="fx-open" title="Otevřít složku">${icon('folder', 16)}</button>
      </div>
      <div class="fx-dirname" title=""></div>
      <div class="fx-list"></div>`;
    this.listEl = this.root.querySelector('.fx-list')!;
    this.dirNameEl = this.root.querySelector('.fx-dirname')!;
    this.root.querySelector('.fx-open')!.addEventListener('click', () => this.chooseFolder());
  }

  private async tryRestore() {
    const dir = await restoreDirectory();
    if (dir) await this.loadDir(dir);
    else this.renderEmpty();
  }

  private async chooseFolder() {
    const dir = await pickDirectory();
    if (dir) await this.loadDir(dir);
  }

  private async loadDir(dir: FileSystemDirectoryHandle) {
    this.dirNameEl.textContent = dir.name;
    this.dirNameEl.title = dir.name;
    try {
      const entries = await listDocx(dir);
      this.renderList(entries);
    } catch {
      this.renderError();
    }
  }

  private renderList(entries: DirEntry[]) {
    this.listEl.innerHTML = '';
    if (!entries.length) {
      this.listEl.innerHTML = '<div class="fx-empty">Ve složce nejsou žádné .docx soubory.</div>';
      return;
    }
    for (const e of entries) {
      const item = document.createElement('button');
      item.className = 'fx-item';
      item.innerHTML = `${icon('newDoc', 15)}<span>${e.name}</span>`;
      item.onclick = async () => {
        this.markActive(item);
        await openFromHandle(e.handle);
      };
      // Zvýrazni aktuálně otevřený soubor.
      if (store.get().doc.fileHandle && store.get().doc.name + '.docx' === e.name) {
        item.classList.add('active');
      }
      this.listEl.appendChild(item);
    }
  }

  private markActive(item: HTMLElement) {
    this.listEl.querySelectorAll('.fx-item').forEach((i) => i.classList.remove('active'));
    item.classList.add('active');
  }

  private renderEmpty() {
    this.listEl.innerHTML = '<div class="fx-empty">Otevřete složku a uvidíte v ní .docx soubory.</div>';
  }

  private renderError() {
    this.listEl.innerHTML = '<div class="fx-empty">Složku se nepodařilo načíst. Zkuste ji otevřít znovu.</div>';
  }
}
